import $ from 'jquery';

class Like {
    constructor() {
        this.events();
    }
    events() {
        $(".like-box").on("click", this.ourClickDispatcher.bind(this));

    }

    //methods
    ourClickDispatcher(e) {
        var currentLikeBox = $(e.target).closest(".like-box");
        if(currentLikeBox.data('isliked') == 'yes') {
            this.deleteLike(currentLikeBox);
        } else {
            this.createLike(currentLikeBox);
        }
    }
    createLike(currentLikeBox)  {
        $.ajax({
            beforeSend: (xhr) =>{
                xhr.setRequestHeader('X-WP-Nonce', braidspressLikeData.nonce);
            },
            url: braidspressData.root_url + '/wp-json/braidspress/v1/manageLike',
            type: 'POST',
            data: {'likedStyleId': currentLikeBox.data('likedstyle')},
            success: (response)=>{
                let count = parseInt(currentLikeBox.find('span').first().text());
                    
                    currentLikeBox.attr('data-isliked', 'yes');
                    currentLikeBox.find('span').first().text(count + 1);

                    currentLikeBox.find('ion-icon').removeClass('text-zinc-600').addClass('text-red-900');                console.log(response);
            },
            error: (response) => {
                console.log(response);
            }
        });
    }
    deleteLike(currentLikeBox) {
        $.ajax({
            beforeSend: (xhr) =>{
                xhr.setRequestHeader('X-WP-Nonce', braidspressLikeData.nonce);
            },
            url: braidspressData.root_url + '/wp-json/braidspress/v1/manageLike',
            type: 'DELETE',
            data: { 'likedStyleId': currentLikeBox.data('likedstyle') },
            success: (response)=>{
                let count = parseInt(currentLikeBox.find('span').first().text());
                    
                    currentLikeBox.attr('data-isliked', 'no');
                    currentLikeBox.find('span').first().text(count - 1);

                    currentLikeBox.find('ion-icon').removeClass('text-red-900').addClass('text-zinc-600');
                    console.log(response);
            },
            error: (response) => {
                console.log(response);
            }
        });
    }
}
export default Like;

// ===========

